import { render, staticRenderFns } from "./WhyChooseUS.vue?vue&type=template&id=64296be4&scoped=true"
import script from "./WhyChooseUS.vue?vue&type=script&lang=js"
export * from "./WhyChooseUS.vue?vue&type=script&lang=js"
import style0 from "./WhyChooseUS.vue?vue&type=style&index=0&id=64296be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64296be4",
  null
  
)

export default component.exports